import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { TextField, TextareaAutosize, Typography, Button, CircularProgress } from "@mui/material";
import * as Yup from "yup";
import Security from "./Security";
import "../../../Myaccount/Myaccount.css";
import Divider from "@mui/material/Divider";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { ToastContainer, toast } from "react-toastify";
import FormControl from "../../../../components/FormControl";
import { useTranslation } from "react-i18next";
import "../../../../Localization/i18n";
import DangerZone from "./DangerZone.jsx";
import CompanyAccess from "./CompanyAccess";
import Eye from "../../../../icons/eye1.svg";
import { Box, InputLabel } from "@mui/material";
import apiinfo from "../../../../utils/base-uri.json";
import axios from "../../../../utils/fvAxios";
import { ConstructionOutlined } from "@mui/icons-material";
import GetfVDateFormate from "../../../../utils/Genaricfunctions";
import _ from "lodash";
import { Link } from "react-router-dom";
import MaskedTextField from "../../../../components/MaskedTextField.jsx";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { invalid } from "moment";
import Delayed from "../../../../utils/Delayed";
import INFO from "../../../../pages/commom/RouteUrlInfo.json";
import PER from "../../../../utils/Enums.json";
import {
  setToken,
  setEmail as setEmailLocalStorage,
  setUserName,
  setGlobalClientId,
  setstatuses,
  getOrgType,
  setOrgType as setOrgTypeLocalStorage,
  setLocalMenus,
  setIncognitoEmail,
  getEmail,
  getOrgId,
  setOrgId,
  HasPermissions,
  HasScreenPermissions,
  HasDeletePermission
} from "../../../../utils/Token";

import UnauthorizedAccess from "../../../UnauthorizedAccess.jsx";
const defaultKeyValues = [
  // {
  //   key: "",
  //   values: [],
  // },
];
export default function UserDetail() {
  const params = new URLSearchParams(window.location.search);
  const userId = params.get("u");
  useEffect(() => {
    getUserDetails();
  }, []);
  const [HasPagePermission, setHasPagePermission] = useState(null);

  const [loading, setloading] = useState(true);
  const getUserDetails = () => {
    setloading(true)
    axios
      .get(apiinfo.settings.GetUserDetail + "?userId=" + userId)
      .then((response) => {
        const res = response.data?.data;
        if (response?.data?.status == false) {
          if (res?.data?.responseMessage == "Access Denied") {
            setHasPagePermission(false);
            setloading(false)
          }
        }
        else {
          setHasPagePermission(true)
          setDetails(res?.data);
          setFirstname(res?.data?.firstName);
          setLastName(res?.data?.lastName);
          setTitle(res?.data?.contactTitle);
          setEmail(res?.data?.email);
          setPhoneNumber(res?.data?.phoneNumber);
          setPhnNumberInternational(res?.data?.phoneNumberInternational);
          setPhoneNumberExt(res?.data?.extNumber);
          setAddDiscription(res?.data?.additionalDescription);
          setOrgType(res?.data?.orgType);
          setEnabledDisabled(res.data?.userStatus ? "Enabled" : "Disabled");
          setDepartmentId(res?.data?.departmentId ?? 0);
          setCanLoginAsUser(response.data?.data?.canLoginAsUser ?? false);
          setIsSuperUser(res?.data?.isSuperUser);
          setCurrentUser_OrgType(res?.data?.orgType);
          setCurrentUserId(res?.data?.userId);
          axios
            .get(apiinfo.Users.GetCurrentUserId)
            .then((resp) => {
              setLoggedInUserId(resp?.data);
            });
          if (res?.data?.orgType === "Client") {
            // setSites(res.data?.clientBUSites);
            setSelectedBU(res?.data.clientBU);
            setSelectedSites(res?.data.clientBUSite);

            res?.data.clientBusinessUnits?.map((site) => {
              const keyExists = defaultKeyValues.some(
                (item) => item.key === site.key
              );

              // check if key already not exist in keyValuePairs
              if (!keyExists) {
                defaultKeyValues.push({
                  key: site.key,
                  values: res?.data.clientBUSites,
                });
              }
            });
            setKeyValuePairs(defaultKeyValues);
          }
        }
      })
      .catch((err) => {
        console.error(err);
      }).finally(() => {
        setloading(false)
      })
  };
  const onRoleSave = () => {
    getUserDetails();
  };

  const [keyValuePairs, setKeyValuePairs] = useState([{}]);
  const [error, setError] = useState("");
  const [details, setDetails] = useState([]);
  const [FirstnameErr, setFirstnameErr] = useState("");
  const [LastNameErr, setLastNameErr] = useState("");
  const [TitleErr, setTitleErr] = useState("");
  const [EmailErr, setEmailErr] = useState("");
  const [PhoneNumberErr, setPhoneNumberErr] = useState("");
  const [MobileNumberErr, setMobileNumberErr] = useState("");
  const [PhoneNumberExtErr, setPhoneNumberExtErr] = useState("");
  const [orgType, setOrgType] = useState("");
  const [enabledDisabled, setEnabledDisabled] = useState("Enabled");
  const [Firstname, setFirstname] = useState("");
  const [LastName, setLastName] = useState("");
  const [Title, setTitle] = useState("");
  const [Email, setEmail] = useState("");
  const [PhoneNumber, setPhoneNumber] = useState("");
  const [phnNumberInternational, setPhnNumberInternational] = useState("");
  const [AddDiscription, setAddDiscription] = useState("");
  const [PhoneNumberExt, setPhoneNumberExt] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImagePath, setSelectedImagePath] = useState(null);
  const [departmentId, setDepartmentId] = useState(null);

  const [sites, setSites] = useState([]);
  const { t } = useTranslation();
  const [selectedSites, setSelectedSites] = useState([]);
  const [selectedBUs, setSelectedBU] = useState([]);
  const [canLoginAsUser, setCanLoginAsUser] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentUser_OrgType, setCurrentUser_OrgType] = useState("");
  const [isSuperUser, setIsSuperUser] = useState(false);
  const [currentUserId, setCurrentUserId] = useState("");
  const [loggedInUserId, setLoggedInUserId] = useState("");

  const validationSchema = Yup.object().shape({
    firstName: Yup.string()
      .required("FirstName is required !")
      .max(20, "First name must not exceed 20 characters"),
    lastName: Yup.string()
      .required("LastName is required !")
      .min(6, "LastName must be at least 6 characters")
      .max(20, "Last name must not exceed 20 characters"),
    title: Yup.string()
      .required("Title is required !")
      .min(6, "Title must be at least 6 characters")
      .max(20, "Title must not exceed 20 characters"),
    phoneNumber: Yup.string()
      .required("Phone number is required !")
      .matches(/^\(\d{3}\) \d{3}-\d{4}$/, "format like (000) 000-0000"),
    mobileNumber: Yup.string()
      .required("Mobile number is required !")
      .typeError("Mobile number is required !")
      .matches(/^\(\d{3}\) \d{3}-\d{4}$/, "format like (000) 000-0000"),
    email: Yup.string()
      .required("Email address is required !")
      .email("Email address is invalid"),
    additionalDescription: Yup.string()
      .required("Additiona iInformation is required !")
      .typeError("Additiona iInformation is required !")
      .min(10, "Additional information must be at least 10 characters"),
  });
  const GetClientBusinessUnits = (e) => { };
  const ChangeFistName = (e) => {
    setFirstname(e);
    // if (e == "") {
    //   setFirstname(e);
    //   setFirstnameErr("Please Enter Field");
    // } else {
    //   setFirstname(e);
    //   setFirstnameErr("");
    // }
  };
  const ChangeLastName = (e) => {
    setLastName(e);
    // if (e == "") {
    //   setLastName("");
    //   setLastNameErr("Please Enter Field");
    // } else {
    //   setLastName(e);
    //   setLastNameErr("");
    // }
  };
  const ChangeTitle = (e) => {
    setTitle(e);
    // if (e == "") {
    //   setTitle(e);
    //   setTitleErr("Please Enter Field");
    // } else {
    //   setTitle(e);
    //   setTitleErr("");
    // }
  };
  const ChangeEmail = (e) => {
    let regEmail = /^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,20})[ ]*$/i; 
    if (e == "") {
      setEmail(e);
      setEmailErr("");
    } else if (!regEmail.test(e)) {
      setEmail(e);
      setEmailErr("Please check email format");
    } else {
      setEmail(e);
      setEmailErr("");
    }
  };
  // const ChangePhonenumber = (e) => {
  //   let regphone = /^\(\d{3}\) \d{3}-\d{4}$/;
  //   if (e == "") {
  //     setPhoneNumber(e);
  //     setPhoneNumberErr("Please Enter Field");
  //   } else if (!regphone.test(e)) {
  //     setPhoneNumber(e);
  //     setPhoneNumberErr("format like (000) 000-0000");
  //   } else {
  //     setPhoneNumber(e);
  //     setPhoneNumberErr("");
  //   }
  // };
  const handleInputChange = (event) => {
    const inputValue = event.target.value;
    const numericInput = inputValue.replace(/[^0-9]/g, '');
    if (numericInput.length <= 10) {
      if (numericInput === '') {
        // Field is empty, no error
        setPhoneNumber('');
        setPhoneNumberErr(false);
      } else if (/^\d{10}$/.test(numericInput)) {
        const formattedInput = `(${numericInput.slice(0, 3)}) ${numericInput.slice(3, 6)}-${numericInput.slice(6)}`;
        setPhoneNumber(formattedInput);
        setPhoneNumberErr(false);
      } else {
        setPhoneNumber(numericInput);
        setPhoneNumberErr(true);
      }
    } else {
      // Limit to 10 digits, no further input allowed
      setPhoneNumber(numericInput.slice(0, 9));
      setPhoneNumberErr(true);
    }
  };
  // const ChangePhonenumberExt = (e) => {
  //   // const regex = /^[0-9]*$/; // Regex to allow numbers only
  //   // if (e.length <= 10 && regex.test(e)) {
  //   //   setPhoneNumberExt(e);
  //   // }

  //   let regphone = /^\(\d{3}\) \d{3}-\d{4}$/;
  //   if (!regphone.test(e)) {
  //     setPhoneNumberExt(e);
  //     setPhoneNumberExtErr("format like (000) 000-0000");
  //   } else {
  //     setPhoneNumberExt(e);
  //     setPhoneNumberExtErr("");
  //   }
  // };

  const ChangePhonenumberExt = (e) => {
    const regex = /^[0-9]*$/; // Regex to allow numbers only
    if (e.length > 10 || !regex.test(e)) {
      setPhoneNumberExtErr("Invalid input");
      setPhoneNumberExt(e);
    } else {
      setPhoneNumberExt(e);
      setPhoneNumberExtErr("");
    }
  };

  const ChangePhnNumberInternational = (e) => {
    const regex = /^[0-9]*$/; // Regex to allow numbers only
    if (e.length >= 13 || !regex.test(e)) {
      setMobileNumberErr("Invalid input");
      setPhnNumberInternational(e);
    } else {
      setPhnNumberInternational(e);
      setMobileNumberErr("");
    }
  };

  const ChangeAdditional = (e) => {
    setAddDiscription(e);
  };
  const ChangeDepartment = (event) => {
    setDepartmentId(event.target.value);
  };

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = () => {
    if (
      Firstname != "" &&
      LastName != "" &&
      Title != "" &&
      Email != "" &&
      PhoneNumber != "" &&
      EmailErr == "" &&
      PhoneNumberErr == "" &&
      MobileNumberErr == "" &&
      PhoneNumberExtErr == ""
    ) {
      let userData = {
        userId: details?.userId,
        firstName: Firstname,
        lastName: LastName,
        contactTitle: Title,
        phoneNumber: PhoneNumber,
        mobileNumber: null,
        phoneNumberInternational: phnNumberInternational,
        additionalDescription: AddDiscription,
        email: Email,
        departmentId: departmentId,
        userStatus: enabledDisabled === "Enabled",
        extNumber: PhoneNumberExt,

        clientBU: selectedBUs?.map((number) => number.toString()),

        clientBUSite: selectedSites?.map((number) => number.toString()),
      };
      axios
        .post(apiinfo.settings.UpdateUserContactDetail, userData)
        .then((res) => {
          if (res?.data?.responseMessage === "Success") {
            toast.success(res.data.responseMessage, {
              position: "top-right",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          } else {
            toast.error(res.data.responseMessage, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          }
        });
    } else {
      //   if (MobileNumberErr != "") {
      //     toast.error("Please check MobileNumber format", {
      //       position: "top-right",
      //       autoClose: 5000,
      //       hideProgressBar: false,
      //       closeOnClick: true,
      //       pauseOnHover: true,
      //       draggable: true,
      //       progress: undefined,
      //       theme: "light",
      //     });
      //   } else {
      toast.error("Please enter mandatory fields", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const getOptions = (responseData) => {
    let options = [];
    responseData?.forEach((pair) => {
      options.push(optionsDataMapper(pair));
    });
    return options;
  };
  function optionsDataMapper({ key, value }) {
    return {
      value: key,
      text: value,
    };
  }

  const handleChange = async (data) => {
    // setSelectedSites([]);
    setSelectedBU(data);
    //removeKeyValuePair(data)
    // for (const id of data) {
    //   await getUnitSites(id, data);
    // }
    // data.length == 0 && setSites([]);
  };
  useEffect(() => {
    if(selectedBUs){
    axios.get("Client/GetBusinessUnitSiteDetails?buSiteIds="+selectedBUs)
        .then((resp) => {
          debugger;
          let newSites = resp?.data?.data?.map((busites) => {
            return {
              key: busites.businessUnitSiteId.toString(),
              value: busites.siteName,
            };
          });
          setSites(newSites)
          // updateKeyValuePairs(buId.toString(), newSites, _selectedBUs);
          // setSelectedSites([]);
        })
        .catch((err) => {
          console.error(err);
        });}
}, [selectedBUs]);

  function handleSitesChange(data) {
    setSelectedSites(data);
  }

  const navigate = useNavigate();

  const navigateToList = () => {
    navigate(getOrgType() != "Admin" ? "/ClientOrVendorUsersList" : "/SearchUser");
  };

  const updateKeyValuePairs = (key, values, _selectedBUs) => {
    const currentPairs = [...keyValuePairs];
    // const currentPairs = _.cloneDeep(keyValuePairs);
    // Check if the key already exists in the array
    const existingPairIndex = currentPairs.findIndex((pair) => pair.key == key);

    if (existingPairIndex !== -1) {
      // If the key exists, replace its values with the new values
      currentPairs[existingPairIndex].values = values;
    } else {
      // If the key doesn't exist, add a new key-value pair to the array
      currentPairs.push({ key, values });
    }

    setKeyValuePairs(
      currentPairs.filter((pair) => _selectedBUs.includes(pair.key.toString()))
    );
    const newSites = [];
    currentPairs
      .filter((pair) => _selectedBUs.includes(pair.key))
      .forEach((n) => {
        newSites.push(
          ...n.values.map((x) => {
            return {
              key: x.key.toString(),
              value: x.value,
            };
          })
        );
      });

    setSites(newSites);
  };
  const removeKeyValuePair = (keys) => {
    setKeyValuePairs((prevState) => {
      const updatedPairs = prevState.filter((pair) => keys.includes(pair.key));
      return updatedPairs;
    });
  };

  // const getUnitSites = async (buId, _selectedBUs) => {
  //   console.log(_selectedBUs);

  //   await axios
    
  //     .get("Client/GetBusinessUnitSiteDetails?buSiteIds="+_selectedBUs)
  //     .then((resp) => {
  //       debugger;
  //       let newSites = resp?.data?.data?.map((busites) => {
  //         return {
  //           key: busites.businessUnitSiteId.toString(),
  //           value: busites.siteName,
  //         };
  //       });

  //       updateKeyValuePairs(buId.toString(), newSites, _selectedBUs);
  //       setSelectedSites([]);
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //     });
  // };
  const handlEnableDisableChange = (event) => {
    setEnabledDisabled(event.target.value);
  };

  // console.log(getOrgType());
  function handleLoginAsSelectedUser(event) {
  
    if (details?.userRole == "") {
      toast.error("The role is not assigned, Please assign the role", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      setIsLoading(true);
      axios
        .post(apiinfo.Users.LoginAsSelectedUser + "?userId=" + userId)
        .then((response) => {
          if (response?.data?.responseCode >= 0) {
            setToken(response?.data?.data?.token);
            setUserName(response?.data?.data?.userName);
            setIncognitoEmail(getEmail());
            setEmailLocalStorage(response?.data?.data?.email);
            setGlobalClientId(response?.data?.data?.globalClientIds);
            setOrgTypeLocalStorage(response?.data?.data?.orgType);
            setLocalMenus(response?.data?.data?.userMenus);
            setOrgId(response?.data?.data?.orgId);

            axios
              .get(apiinfo.dashboard.GetprequalificationStatuses)
              .then((res) => {
                if (res?.data?.status === true) {
                  setstatuses(res?.data?.data);
                } else {
                  alert(res.data.responseMessage);
                }
              });
            setIsLoading(false);


            if (event.ctrlKey) {
              // window.location.reload();
              // window.location = "/DashBoard";
              const channel = new BroadcastChannel('refresh_channel');
              channel.postMessage('refresh');
              window.open("/DashBoard", "_blank");

            } else {
              window.location = "/DashBoard";
            }

          } else {
            setIsLoading(false);
            toast.error(response?.data?.responseMessage, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          }
        });
    }
  }

  return (
    <>
      <ToastContainer />
      {HasPagePermission ? (
        <div
          className="row bg"
          style={{
            minwidth: "100%",
            backgroundColor: "#F9FAFB",
            marginLeft: "auto",
          }}
        >
          <div className="col-sm-2 md-2 xl-2 block ">
            <Link
              to={getOrgType() != "Admin" ? "/ClientOrVendorUsersList" : "/SearchUser"}
              style={{
                textTransform: "capitalize",
                textDecoration: "none",
                color: "rgb(97, 169, 251)",
              }}
            >
              {"<-- Back to Users"}
            </Link>
          </div>
          <div className="col-sm-9 md-9 xl-9">
            <Box sx={{ width: "100%" }}>
              <span className="mx-5">
                <h1 className="mx-5 mt-3" style={{ color: "rgb(0,0,0)" }}>
                  User Details
                </h1>
              </span>
              {HasPermissions(INFO?.UpdateNewUserContactDetails?.actionName, PER?.ScreenPermissions?.Read) &&
                // {!HasScreenPermissions(INFO?.UpdateNewUserContactDetails?.actionName) &&
                <div className="form">
                  <label className="personal-info-heading">
                    <b>Main info</b>
                  </label>
                  <div className="mx-3">
                    {isLoading ? (
                      <Box sx={{ display: "flex", padding: "10px" }}>
                        <CircularProgress />
                      </Box>
                    ) : (
                      <p
                        style={{
                          textTransform: "capitalize",
                          textDecoration: "none",
                          color: "rgb(97, 169, 251)",

                          cursor: "pointer"
                        }}
                        hidden={getOrgType() != "Admin" || canLoginAsUser != true}
                        onClick={handleLoginAsSelectedUser}
                      >
                        <RemoveRedEyeOutlinedIcon /> User View - {Email || ""}
                      </p>

                    )}
                  </div>
                  <label
                    className="personal-info-heading"
                    style={{ color: "#2A93DB" }}
                  >
                    {/* <h6>
                  <img src={Eye} alt="eyeicon" /> User View - user6@user.com
                 </h6> */}
                  </label>
                  <div className="personal-info-subheading">
                    <span>
                      {t("Myinformation.lastlogin")}:{" "}
                      {details?.lastLoginDate &&
                        GetfVDateFormate("", details?.lastLoginDate)}
                    </span>
                  </div>

                  <div className="personal-info-subheading">
                    <span>
                      {t("Myinformation.lastPasswordChangedDate")}:
                      {details?.lastLoginDate &&
                        GetfVDateFormate("", details?.lastPasswordChangedDate)}
                    </span>
                  </div>


                  <Divider className="mt-3" />

                  <div className="row mt-2">
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                      <span className="input-label-right">User Enabled</span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                      <RadioGroup
                        className="mx-2"
                        required
                        type="radio"
                        value={enabledDisabled}
                        id="enabledDisabled"
                        name="enabledDisabled"
                        onChange={handlEnableDisableChange}
                      >
                        <FormControlLabel
                          value="Enabled"
                          control={<Radio />}
                          label="Enabled"
                        />
                        <FormControlLabel
                          value="Disabled"
                          control={<Radio />}
                          label="Disabled"
                        />
                      </RadioGroup>
                      <Typography
                        className="text-danger mx-2 mt-1"
                        component={"span"}
                      >
                        {errors.acceptVendors?.message}
                      </Typography>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
                  </div>

                  <Divider className="mt-3" />

                  <div className="row mt-2">
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-4">
                      <span className="input-label-right">
                        {t("Myinformation.firstname")}{" "}
                        <small style={{ color: "red" }}>*</small>
                      </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                      <TextField
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        size="small"
                        required
                        id="firstName"
                        name="firstName"
                        value={Firstname || ""}
                        placeholder={t("Myinformation.firstname")}
                        className="form-control text-feild-custom mx-2"
                        onChange={(e) => ChangeFistName(e.target.value)}
                      />
                      <Typography
                        className="text-danger mx-2 mt-1"
                        component={"span"}
                      >
                        {FirstnameErr}
                      </Typography>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
                  </div>
                  <Divider className="mt-3" />
                  <div className="row mt-2">
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                      <span className="input-label-right">
                        {t("Myinformation.lastname")}{" "}
                        <small style={{ color: "red" }}>*</small>
                      </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                      <TextField
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        required
                        id="lastName"
                        name="lastName"
                        value={LastName || ""}
                        placeholder={t("Myinformation.lastname")}
                        size="small"
                        className="form-control text-feild-custom mx-2"
                        onChange={(e) => ChangeLastName(e.target.value)}
                      />
                      <Typography
                        className="text-danger mx-2 mt-1"
                        component={"span"}
                      >
                        {LastNameErr}
                      </Typography>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
                  </div>
                  <Divider className="mt-3" />
                  <div className="row mt-2">
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                      <span className="input-label-right">
                        {t("Myinformation.title")}{" "}
                        <small style={{ color: "red" }}>*</small>
                      </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                      <TextField
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        required
                        id="title"
                        name="title"
                        value={Title || ""}
                        placeholder={t("Myinformation.title")}
                        size="small"
                        className="form-control text-feild-custom mx-2"
                        onChange={(e) => ChangeTitle(e.target.value)}
                      />
                      <Typography
                        className="text-danger mx-2 mt-1"
                        component={"span"}
                      >
                        {TitleErr}
                      </Typography>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
                  </div>
                  <Divider className="mt-3" />

                  <div className="row mt-2">
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3 ">
                      <span className="input-label-right">
                        {t("Myinformation.email")}
                        <small style={{ color: "red" }}>*</small>
                      </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                      <TextField
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        required
                        id="email"
                        name="email"
                        value={Email || ""}
                        disabled={getOrgType() != "Admin"}
                        placeholder={t("Myinformation.email")}
                        size="small"
                        className="form-control text-feild-custom mx-2"
                        onChange={(e) => ChangeEmail(e.target.value)}
                      />
                      <Typography
                        className="text-danger mx-2 mt-1"
                        component={"span"}
                      >
                        {EmailErr}
                      </Typography>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
                  </div>
                  <Divider className="mt-3" />
                  <div className="row mt-2">
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                      <span className="input-label-right">
                        {t("Myinformation.phonenumber")}{" "}
                        <small style={{ color: "red" }}>*</small>
                      </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                      {/* <MaskedTextField
                      mask="(999) 999-9999"
                      placeholder="+1 (555) 000-0000"
                      value={PhoneNumber || ""}
                      onChange={ChangePhonenumber}
                      className="form-control text-feild-custom mx-2"
                      size="small"
                    /> */}
                      <TextField
                        sx={{
                          '& legend': { display: 'none' },
                          '& fieldset': { top: 0 },
                        }}
                        value={PhoneNumber || ""}
                        onInput={handleInputChange}
                        size="small"
                        placeholder={t("Myinformation.phonenumber")}
                        id="outlined-name"
                        variant="outlined"
                        className="form-control text-feild-custom mx-2"
                        error={PhoneNumberErr}
                        helperText={PhoneNumberErr ? 'Invalid  format. Use (xxx) xxx-xxxx' : ''}
                      />
                      {/* <Typography
                      className="text-danger mx-2 mt-1"
                      component={"span"}
                    >
                      {PhoneNumberErr}
                    </Typography> */}
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
                  </div>
                  <Divider className="mt-3" />
                  <div className="row mt-2">
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                      <span className="input-label-right">
                        {t("Myinformation.phonenumberInternational")}{" "}
                      </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                      <TextField
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        type="text"
                        id="mobileNumber"
                        name="mobileNumber"
                        size="small"
                        placeholder="Phone Number International"
                        value={phnNumberInternational || ""}
                        className="form-control text-feild-custom mx-2"
                        onChange={(e) =>
                          ChangePhnNumberInternational(e.target.value)
                        }
                      />
                      <Typography
                        className="text-danger mx-2 mt-1"
                        component={"span"}
                      >
                        {MobileNumberErr}
                      </Typography>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
                  </div>
                  <Divider className="mt-3" />
                  <div className="row mt-2">
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                      <span className="input-label-right">
                        Phone Number Extension{" "}
                      </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                      <TextField
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        required
                        type="text"
                        id="Phonenumberextension"
                        value={PhoneNumberExt || ""}
                        name="Phonenumberextension"
                        placeholder="Phone Number Extension"
                        size="small"
                        className="form-control text-feild-custom mx-2"
                        onChange={(e) => ChangePhonenumberExt(e.target.value)}
                      />


                      {/* <MaskedTextField
                      mask="(999) 999-9999"
                      placeholder="+1 (555) 000-0000"
                      value={PhoneNumberExt || ""}
                      onChange={ChangePhonenumberExt}
                      className="form-control text-feild-custom mx-2"
                      size="small"
                    /> */}
                      <Typography
                        className="text-danger mx-2 mt-1"
                        component={"span"}
                      >
                        {PhoneNumberExtErr}
                      </Typography>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
                  </div>

                  <Divider className="mt-3" />
                  <div className="row mt-2">
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                      <span className="input-label-right">
                        {" "}
                        {t("Myinformation.additional")}{" "}
                      </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1 ">
                      <TextareaAutosize
                        minRows={3}
                        required
                        id="additionalDescription"
                        value={AddDiscription}
                        name="additionalDescription"
                        placeholder={t("Myinformation.additional")}
                        size="small"
                        className="form-control text-feild-custom mx-2"
                        onChange={(e) => ChangeAdditional(e.target.value)}
                      />
                    </div>
                  </div>

                  {/* {orgType === "Client" && (
                    <div className="row mt-2">
                      <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">
                          {" "}
                          {t("Myinformation.department")}{" "}
                        </span>
                      </div>
                      <div className="col-sm-4 col-md-4 col-xl-4 mt-1 ">
                        <Select
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          value={departmentId}
                          required
                          size="small"
                          placeholder="Department"
                          name="department"
                          id="department"
                          className="form-control text-feild-custom mx-2 border-0"
                          onChange={ChangeDepartment}
                        >
                          {details.department?.map((r, index) => (
                            <MenuItem key={index} value={r.value}>
                              {r.key}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                    </div>
                  )} */}

                  {orgType === "Client" && (
                    <>
             
                      <Divider className="mt-3" hidden={getOrgType()=="Client"}/>
                      <div className="row mt-3 mb-3" hidden={getOrgType()=="Client"}>
                        <span className="input-label-right">
                          {" "}
                          {t(
                            "Please select the business unit and all locations that the user will be allowed to view"
                          )}{" "}
                        </span>
                        <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                          <div className="ms-3">
                            <FormControl
                              fieldId={"Client"}
                              required={false}
                              label={""}
                              inputType="select"
                              multiple={true}
                              items={getOptions(details.clientBusinessUnits)}
                              value={selectedBUs || ""}
                              handleChange={(value) => handleChange(value)}
                              width={"100%"}
                              disabled={false}
                              heighlight={"false"}
                            />
                          </div>
                        </div>
                        <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                          <div className="ms-1">
                            <FormControl
                              fieldId={"Client"}
                              required={false}
                              label={""}
                              inputType="select"
                              multiple={true}
                              items={getOptions(sites)}
                              value={selectedSites || ""}
                              handleChange={(value) => handleSitesChange(value)}
                              width={"100%"}
                              disabled={false}
                              heighlight={"false"}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  <Divider className="mt-3" />
                  <div className="row mt-3 mb-3">
                    <div className="text-right">
                      <Button
                        variant="outlined"
                        color="primary"
                        style={{
                          marginRight: "10px",
                          textTransform: "capitalize",
                          padding: "15px",
                        }}
                        onClick={navigateToList}
                      >
                        {t("Myinformation.cancle")}
                      </Button>
                      {HasPermissions(INFO?.UpdateNewUserContactDetails?.actionName, PER?.ScreenPermissions?.Modify) &&
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={onSubmit}
                          style={{ textTransform: "capitalize", padding: "15px" }}
                          disabled={EmailErr ||
                            PhoneNumberErr ||
                            MobileNumberErr ||
                            PhoneNumberExtErr}
                        >
                          {t("Myinformation.save")}
                        </Button>
                      }
                    </div>
                  </div>
                </div>
              }

              {/* {!HasScreenPermissions(INFO?.UpdateNewUserContactDetails?.actionName) && */}
              {HasPermissions(INFO?.UpdateNewUserContactDetails?.actionName, PER?.ScreenPermissions?.Read) &&
                (<div>
                  {getOrgType() === "Admin" && (
                    <div className="mt-3">
                      <Security
                        date={GetfVDateFormate(
                          null,
                          details.lastPasswordChangedDate
                        )}
                        userId={userId}
                        navigateToList={navigateToList}
                        MOD={HasPermissions(INFO?.UpdateNewUserContactDetails?.actionName, PER?.ScreenPermissions?.Modify)}
                      />
                    </div>
                  )}
                </div>)
              }

              {/* {!HasScreenPermissions(INFO?.AddCompanyAccess?.actionName) && */}
              {HasPermissions(INFO?.AddCompanyAccess?.actionName, PER?.ScreenPermissions?.Read) &&
                <div className="mt-3">
                  <CompanyAccess
                    userId={userId}
                    orgId={details.orgId}
                    onRoleSave={onRoleSave}
                    orgName={details.orgName}
                    userRole={details.userRole}
                    SuperUser={isSuperUser}
                    PrincipalCompanyOfficerName={details?.principalCompanyOfficerName}
                    MOD={HasPermissions(INFO?.AddCompanyAccess?.actionName, PER?.ScreenPermissions?.Modify)}
                  />
                </div>
              }
              {currentUser_OrgType !== "Admin" &&
                !isSuperUser &&
                loggedInUserId !== currentUserId && (
                  <div
                    className="mt-3"
                    hidden={HasDeletePermission(INFO?.UpdateNewUserContactDetails?.actionName)}
                  >
                    <DangerZone userId={userId} />
                  </div>
                )}
            </Box>
          </div>
        </div>
      ) : (
        <div hidden={loading}>
          <Delayed waitBeforeShow={2000}>
            <UnauthorizedAccess />
          </Delayed>
        </div>


      )}
    </>
  );
}
